import type { FC } from 'react';
import { Dropdown } from '@components/Dropdown';
import { SortToggleButton } from '@components/SortToggleButton';
import { SortAscendingIcon, SortDescendingIcon } from '@heroicons/react/solid';

import type { ActivityUser } from '../utils/derive-users';

export type ActivitySort = 'newest' | 'oldest';
export const EVERYONE = 'everyone';

interface ActivityControlsProps {
  users: ActivityUser[];
  filterKey: string;
  onFilter: (key: string) => void;
  sort: ActivitySort;
  onToggleSort: () => void;
}

export const ActivityControls: FC<ActivityControlsProps> = ({ users, filterKey, onFilter, sort, onToggleSort }) => {
  const options = [{ label: 'Everyone', value: EVERYONE }, ...users.map((u) => ({ label: u.name, value: u.key }))];

  return (
    <div className="flex items-center gap-4 px-7.5 py-4">
      <Dropdown
        ariaLabel="Filter by user"
        dataTestId="activity-filter-dropdown"
        options={options}
        value={filterKey}
        onChange={onFilter}
        className="flex-1"
      />
      <SortToggleButton
        dataTestId="activity-sort-button"
        actionLabel={sort === 'newest' ? 'Sort Oldest' : 'Sort Newest'}
        icon={sort === 'newest' ? SortAscendingIcon : SortDescendingIcon}
        onClick={onToggleSort}
      />
    </div>
  );
};
